// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CutOutlinedSvg from "@fishx/icons-svg/es/asn/CutOutlined";
import FishxIcon from '../components/FishxIcon';

var CutOutlined = function CutOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CutOutlinedSvg
  }));
};

CutOutlined.displayName = 'CutOutlined';
export default React.forwardRef(CutOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CutOutlined.js
// module id = 2361
// module chunks = 0